@if (positionAndWeatherStore.currentsAndSeaWater()) {
  <form
    #form="ngForm"
    novalidate
    class="flex flex-col gap-1"
  >
    @let vm = offshoreReportStore.vm();

    <nsp-select-input
      name="seaSwell"
      id="seaSwell"
      label="Sea Swell"
      [options]="swellOptions"
      [labelWidthPercentage]="33"
      [required]="vm.isFieldRequired(tabId, sectionId, 'seaSwell')"
      [readonly]="vm.isFieldReadOnly(tabId, sectionId, 'seaSwell')"
      [value]="positionAndWeatherStore.currentsAndSeaWater().seaSwell.value"
      [ngModel]="positionAndWeatherStore.currentsAndSeaWater().seaSwell.value"
    />
    <nsp-number-input
      name="waveHeight"
      id="waveHeight"
      label="Wave Height"
      [unit]="units.meters"
      [labelWidthPercentage]="33"
      [required]="vm.isFieldRequired(tabId, sectionId, 'waveHeight')"
      [readonly]="vm.isFieldReadOnly(tabId, sectionId, 'waveHeight')"
      [min]="0"
      [value]="positionAndWeatherStore.currentsAndSeaWater().waveHeight.value"
      [ngModel]="positionAndWeatherStore.currentsAndSeaWater().waveHeight.value"
    />
    <nsp-number-input
      name="waterDepth"
      id="waterDepth"
      label="Water Depth"
      [unit]="units.meters"
      [labelWidthPercentage]="33"
      [required]="vm.isFieldRequired(tabId, sectionId, 'waterDepth')"
      [readonly]="vm.isFieldReadOnly(tabId, sectionId, 'waterDepth')"
      [min]="0"
      [value]="positionAndWeatherStore.currentsAndSeaWater().waterDepth.value"
      [ngModel]="positionAndWeatherStore.currentsAndSeaWater().waterDepth.value"
    />
    <nsp-number-input
      name="currentDirectionTrueNorth"
      id="currentDirectionTrueNorth"
      label="Current Direction (True North)"
      [unit]="units.degrees"
      [labelWidthPercentage]="33"
      [required]="
        vm.isFieldRequired(tabId, sectionId, 'currentDirectionTrueNorth')
      "
      [readonly]="
        vm.isFieldReadOnly(tabId, sectionId, 'currentDirectionTrueNorth')
      "
      [min]="0"
      [value]="
        positionAndWeatherStore.currentsAndSeaWater().currentDirectionTrueNorth
          .value
      "
      [ngModel]="
        positionAndWeatherStore.currentsAndSeaWater().currentDirectionTrueNorth
          .value
      "
    />
    <nsp-number-input
      name="trueCurrentSpeed"
      id="trueCurrentSpeed"
      label="True Current Speed"
      [unit]="units.knots"
      [labelWidthPercentage]="33"
      [required]="vm.isFieldRequired(tabId, sectionId, 'trueCurrentSpeed')"
      [readonly]="vm.isFieldReadOnly(tabId, sectionId, 'trueCurrentSpeed')"
      [min]="0"
      [value]="
        positionAndWeatherStore.currentsAndSeaWater().trueCurrentSpeed.value
      "
      [ngModel]="
        positionAndWeatherStore.currentsAndSeaWater().trueCurrentSpeed.value
      "
    />
    <nsp-number-input
      name="apparentCurrentDirection"
      id="apparentCurrentDirection"
      label="Apparent Current Direction"
      [unit]="units.degrees"
      [labelWidthPercentage]="33"
      [required]="
        vm.isFieldRequired(tabId, sectionId, 'apparentCurrentDirection')
      "
      [readonly]="
        vm.isFieldReadOnly(tabId, sectionId, 'apparentCurrentDirection')
      "
      [min]="0"
      [value]="positionAndWeatherStore.vm().apparentCurrentDirection"
      [ngModel]="positionAndWeatherStore.vm().apparentCurrentDirection"
    />
    <nsp-number-input
      name="apparentCurrentSpeed"
      id="apparentCurrentSpeed"
      label="Apparent Current Speed"
      [unit]="units.knots"
      [labelWidthPercentage]="33"
      [required]="vm.isFieldRequired(tabId, sectionId, 'apparentCurrentSpeed')"
      [readonly]="vm.isFieldReadOnly(tabId, sectionId, 'apparentCurrentSpeed')"
      [min]="0"
      [value]="positionAndWeatherStore.vm().apparentCurrentSpeed"
      [ngModel]="positionAndWeatherStore.vm().apparentCurrentSpeed"
    />
    <nsp-number-input
      name="apparentWaveDirection"
      id="apparentWaveDirection"
      label="Apparent Wave Direction"
      [unit]="units.degrees"
      [labelWidthPercentage]="33"
      [required]="vm.isFieldRequired(tabId, sectionId, 'apparentWaveDirection')"
      [readonly]="vm.isFieldReadOnly(tabId, sectionId, 'apparentWaveDirection')"
      [min]="0"
      [value]="
        positionAndWeatherStore.currentsAndSeaWater().apparentWaveDirection
          .value
      "
      [ngModel]="
        positionAndWeatherStore.currentsAndSeaWater().apparentWaveDirection
          .value
      "
    />
    <nsp-number-input
      name="seaTemperature"
      id="seaTemperature"
      label="Sea Temperature"
      [unit]="units.degreesCelsius"
      [labelWidthPercentage]="33"
      [required]="vm.isFieldRequired(tabId, sectionId, 'seaTemperature')"
      [readonly]="vm.isFieldReadOnly(tabId, sectionId, 'seaTemperature')"
      [min]="0"
      [value]="
        positionAndWeatherStore.currentsAndSeaWater().seaTemperature.value
      "
      [ngModel]="
        positionAndWeatherStore.currentsAndSeaWater().seaTemperature.value
      "
    />
    <nsp-number-input
      name="seaWaterDensity"
      id="seaWaterDensity"
      label="Sea Water Density"
      [unit]="units.gramsPerMl"
      [labelWidthPercentage]="33"
      [required]="vm.isFieldRequired(tabId, sectionId, 'seaWaterDensity')"
      [min]="0"
      [value]="
        positionAndWeatherStore.currentsAndSeaWater().seaWaterDensity.value
      "
      [ngModel]="
        positionAndWeatherStore.currentsAndSeaWater().seaWaterDensity.value
      "
    />
    <nsp-number-input
      name="atmosphericPressure"
      id="atmosphericPressure"
      label="Atmospheric Pressure"
      [unit]="units.millibar"
      [labelWidthPercentage]="33"
      [required]="vm.isFieldRequired(tabId, sectionId, 'atmosphericPressure')"
      [readonly]="vm.isFieldReadOnly(tabId, sectionId, 'atmosphericPressure')"
      [min]="0"
      [value]="
        positionAndWeatherStore.currentsAndSeaWater().atmosphericPressure.value
      "
      [ngModel]="
        positionAndWeatherStore.currentsAndSeaWater().atmosphericPressure.value
      "
    />
    <nsp-number-input
      name="salinity"
      id="salinity"
      label="Salinity"
      [unit]="units.partsPerMillion"
      [labelWidthPercentage]="33"
      [required]="vm.isFieldRequired(tabId, sectionId, 'salinity')"
      [readonly]="vm.isFieldReadOnly(tabId, sectionId, 'salinity')"
      [min]="0"
      [value]="positionAndWeatherStore.currentsAndSeaWater().salinity.value"
      [ngModel]="positionAndWeatherStore.currentsAndSeaWater().salinity.value"
    />
  </form>
}
